import { REFERRAL_SENDER_OFFER_LOOKUP, SenderOfferName } from './data';

export const getReferralSenderOffer = (offerName: SenderOfferName) => {
  return REFERRAL_SENDER_OFFER_LOOKUP[offerName];
};
